"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.headerComponent = void 0;
const app_1 = require("app");
const Header_1 = require("./components/Header");
const dictionary_1 = require("./dictionary");
class HeaderComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.header';
    }
    OnInit() {
        const headerElement = this.el[0];
        if (!headerElement) {
            return;
        }
        const headerData = app_1.AttrService.data(headerElement, 'header-data');
        const dictionary = (0, app_1.transformDictionary)(dictionary_1.headerDictionary, app_1.AttrService.data(headerElement, 'dictionary'));
        const genericSearchPageSelector = '#search-results-page-react:not(.documents-search-results-page)';
        const isGenericSearchPage = document.querySelectorAll(genericSearchPageSelector).length > 0;
        const isAutosuggestionRedirect = !isGenericSearchPage;
        (0, Header_1.RenderHeader)({
            headerData: Object.assign(Object.assign({}, headerData), { isAutosuggestionRedirect }),
            headerElement,
            dictionary,
        });
    }
}
exports.headerComponent = new HeaderComponent();
